export default __webpack_public_path__ + "static/media/BannerCS-10May(360x600).d2308e2b.webp";